import http from "@/http";
// 添加角色
export const addRole = {
  p: "/api/role/add",
  r: data => {
    return http({
      url: "/api/role/add",
      method: "post",
      data
    });
  }
};
// 获取角色列表
export const getRoleList = {
  p: "/api/role/list",
  r: data => {
    return http({
      url: "/api/role/list",
      method: "post",
      data
    });
  }
};

// 根据id获取角色详情
export const getRoleItem = {
  p: "/api/role/details",
  r: data => {
    return http({
      url: "/v1/role/read/" + data.id,
      method: "get"
    });
  }
};
// 根据id删除角色
export const deleteRole = {
  p: "/api/role/delete",
  r: data => {
    return http({
      url: "/api/role/delete",
      method: "post",
      data
    });
  }
};
// 更新角色信息
export const updateRole = {
  p: "/api/role/edit",
  r: data => {
    return http({
      url: "/api/role/edit",
      method: "post",
      data
    });
  }
};
// 根据角色id获取角色菜单权限
export const getRoleMenu = {
  p: "/api/role/roleMenuTree/",
  r: data => {
    return http({
      url: "/api/role/roleMenuTree/" + data.id,
      method: "get"
    });
  }
};
// 获取角色id
// http://base.leubao.com/api/role/all
export const getroleAll = {
  p: "/api/role/all",
  r: data => {
    return http({
      url: "/api/role/all",
      method: "get"
    });
  }
};
